import type {NewTicketAttachment, TicketTag} from '../../types';

import {TextArea} from '@ds/components';
import AttachmentItem from 'common/ticketing-details/AttachmentItem';
import AttachmentUploader from 'common/ticketing-details/AttachmentUploader';
import {downloadAttachment, uploadFiles} from 'store/slices/ticket/thunk';

import TicketTagDescription from './components/TicketTagDescription/TicketTagDescription';

type TicketDetailsFormProps = {
  vendorId: string | number;
  selectedTag: TicketTag;
  comment: string;
  files: NewTicketAttachment[];
  onCommentChange: (value: string) => void;
  onUploadSuccess: (file: NewTicketAttachment) => void;
  onRemoveFile: (file: NewTicketAttachment) => void;
};

const TicketDetailsForm: React.FC<TicketDetailsFormProps> = ({
  vendorId,
  selectedTag,
  comment,
  files,
  onCommentChange,
  onUploadSuccess,
  onRemoveFile
}) => {
  return (
    <>
      <div className="flex flex-col gap-2.5 p-5">
        <span className="text-subtitle-md">موضوع تیکت شما</span>
        <span className="text-body-md text-gray-07">{selectedTag.title}</span>
      </div>

      <div className="px-5">
        <TicketTagDescription
          key={`${vendorId}:${selectedTag.id}`}
          tagId={selectedTag.id}
          vendorId={vendorId}
        />
      </div>

      <div className="flex flex-col gap-2.5 p-5">
        <label className="text-body-sm text-gray-08" htmlFor="new-ticket-description">
          نیاز به توضیح بیشتری دارید؟ اینجا بنویسید
        </label>
        <TextArea
          id="new-ticket-description"
          className="w-full"
          rows={6}
          placeHolder="لطفا جزییات درخواست را توضیح دهید"
          value={comment}
          onChange={(event) => onCommentChange(event.target.value)}
        />
        <span className="text-body-xs text-gray-06">توضیحات بایستی بیشتر از ۱۰ حرف باشد.</span>
        <AttachmentUploader
          vendorId={vendorId}
          uploadAttachment={uploadFiles}
          onUploadSuccess={(response) => onUploadSuccess(response.data)}
        />
        <div className="flex flex-col gap-2.5">
          {files.map((file) => (
            <AttachmentItem
              key={file.file_key}
              file={file}
              vendorId={vendorId}
              downloadAttachment={downloadAttachment}
              removable
              onRemove={(attachment) => {
                if (attachment.file_key) {
                  onRemoveFile({...attachment, file_key: attachment.file_key});
                }
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default TicketDetailsForm;
